// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.0-beta.61415bae1',
  revision: '61415bae1',
  branch: 'develop',
  date: 'Fri, 22 May 2026 16:05:24 GMT'
};